// @ts-nocheck
import * as Types from '../../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables = Types.Exact<{
  shipmentId: Types.Scalars['ID']['input'];
}>;


export type GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery = { __typename?: 'Query', isPurchasedShipmentToys: boolean };


export const GetIsPurchasedShipmentToysPagesPurchaseShipmentIdDocument = gql`
    query GetIsPurchasedShipmentToysPagesPurchaseShipmentId($shipmentId: ID!) {
  isPurchasedShipmentToys(shipmentUuid: $shipmentId)
}
    `;

/**
 * __useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery__
 *
 * To run a query within a React component, call `useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables> & ({ variables: GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables>(GetIsPurchasedShipmentToysPagesPurchaseShipmentIdDocument, options);
      }
export function useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables>(GetIsPurchasedShipmentToysPagesPurchaseShipmentIdDocument, options);
        }
export function useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables>(GetIsPurchasedShipmentToysPagesPurchaseShipmentIdDocument, options);
        }
export type GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryHookResult = ReturnType<typeof useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery>;
export type GetIsPurchasedShipmentToysPagesPurchaseShipmentIdLazyQueryHookResult = ReturnType<typeof useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdLazyQuery>;
export type GetIsPurchasedShipmentToysPagesPurchaseShipmentIdSuspenseQueryHookResult = ReturnType<typeof useGetIsPurchasedShipmentToysPagesPurchaseShipmentIdSuspenseQuery>;
export type GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryResult = Apollo.QueryResult<GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQuery, GetIsPurchasedShipmentToysPagesPurchaseShipmentIdQueryVariables>;